var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Sobald andere Geräte, die sich im selben (W)LAN-Netztwerk befinden, XidrasTransfer öffnen, kannst du diese rund um dich sehen. ")])}
var staticRenderFns = []

export { render, staticRenderFns }